import React from "react";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useCreateLeadMutation } from "store/services/vendorLeadApi";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { VendorLeadForm } from "./vendorLeadComponents/VendorLeadForm";

const breadcrumbs = [
  { title: "Leads", path: "/app/crm/vendor-lead/list" },
  { title: "New Lead" },
];

export const VendorLeadCreateScreen = () => {
  const navigate = useNavigate();
  const [createLead, { isLoading: creatingLead }] = useCreateLeadMutation();

  const handleCreateLead = async (payload) => {
    try {
      const res = await createLead(payload).unwrap();
      toast.success("Lead created successfully");
      navigate(`/app/crm/vendor-lead/${res?._id}/detail`);
    } catch (err) {
      toast.error(err?.data?.message ?? err?.message ?? "Couldn't create lead");
    }
  };

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingLead}>
      <BreadcrumbLayout.Paper>
        <VendorLeadForm onSubmit={handleCreateLead} isBusy={creatingLead} />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};